
<div
  :class="[
    'vue-star-rating',
    { 'vue-star-rating-rtl': rtl },
    { 'vue-star-rating-inline': inline },
  ]"
>
  <div class="vue-star-rating" @mouseleave="resetRating">
    <span
      v-for="n in maxRating"
      :key="n"
      :class="[{ 'vue-star-rating-pointer': !readOnly }, 'vue-star-rating-star']"
      :style="{ 'margin-right': margin + 'px' }"
    >
      <star
        :fill="fillLevel[n - 1]"
        :size="starSize"
        :points="starPoints"
        :star-id="n"
        :step="step"
        :active-color="activeColor"
        :inactive-color="inactiveColor"
        :border-color="borderColor"
        :border-width="borderWidth"
        :rounded-corners="roundedCorners"
        :rtl="rtl"
        :glow="glow"
        :glow-color="glowColor"
        @star-selected="setRating($event, true)"
        @star-mouse-move="setRating"
      ></star>
    </span>
    <span v-if="showRating" :class="['vue-star-rating-rating-text', textClass]">
      {{ formattedRating }}</span
    >
  </div>
</div>
